import { DraggedSingleData } from "../../../../components/ui/DragToolsUI";
import { HudActions } from "../../../../components/ui/hud/HUDUI";
import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../misc/constants";
import { globals } from "../../../../misc/globals";
import { DaarcBaseScenario } from "../../../DaarcBaseScenario";
import GeneralNeutralStateMain, { GeneralNeutralStatePart6Config, GeneralNeutralStateMainConfig } from "../GeneralNeutralStateMain";


export default class GeneralNeutralStatePart6 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralNeutralStatePart6Config {
		return this.scenarioConfig.part6Config;
	}
	constructor(private main: GeneralNeutralStateMain, private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralNeutralStateMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;
		context._scenario.currentTaskMessage = 'Call for advanced airway cart with flexible bronchoscopy';
		context._scenario.uiWrapper.displayHUD({
			score: context._scenario.totalScore,
			maxScore: this._scenario.maxScore,
			onActionClicked: (actionType: HudActions, icon: string, title: string) => {
				if(context.main.onHudActionClicked(actionType, icon, title)) {
					return true;
				}
				switch(actionType) {
					case HudActions.CallForFiberopticLaryngoscope:
						context.laryngoscope(title);						
						return true;
					default:
						if(context.config.onSettingUpAnythingElse) {
							context.config.onSettingUpAnythingElse();
						}
						context._scenario.displayMessage(context._scenario.currentTaskMessage);
						return false;
				}
			}
		}, context._scenario.hudId);

		if(!context.main.config.isTestScenario && !context.main.config.isEmanuelMcKenzie) {
			context.scenario.toolbagId = context._scenario.uiWrapper.displayToolbag({
				onShouldShowOverlay: () => {
					return false;
				},
				onToolClicked: (data: DraggedSingleData) => {
					context._scenario.displayMessage(context.scenarioConfig.isTestScenario ? context.main.toolsMessageTestScenario : context._scenario.currentTaskMessage);
				}
			}, context._scenario.toolbagId);
		}
	}

	public laryngoscope(title: string) {
		const context = this;
		if(context.config.onSetupFiberOptic) {
			context.config.onSetupFiberOptic();
		}
		if(this.scenarioConfig.isEmanuelMcKenzie) {
			context.scenario.uiWrapper.displayGeneralAlertUI({
				title: 'Airway Management Urgent',
				text: 'Airway management is urgent. fiberoptic will not arrive in time. Therefore, calling for fiberoptic wastes critical time.',
				okButton: {
					title: 'OK',
					onClicked: () => {
						context.onDone()
					}
				}
			});
		} else {
			var onDoneWithPopup = context._scenario.doSomething('Calling for Advanced Airway Cart');
			
			// context.scenario.debriefLog('Setup fiber optic');
			var suffix = 'PH';
			switch(title) {
				case 'respiratoryTherapist':
					suffix = 'RT';
					break;
				case 'nurse':
					suffix = 'RN';
					break;
			}
			// context.playVideoChapter(context.config.waitForFiberOpticVideoChapter(), () => {
				
			// })

			setTimeout(() => {
				onDoneWithPopup();
				context.scenario.gameManager.SoundManager.playSound({
					src: './assets/audio/hud/DC-S03-FB-120a_' + suffix + '.mp3',
					autoPlay: true,
					enableClosedCaptioning: false,
					muted: globals.isMuted,
					volume: 1
				});
				var txt = this.config.notificationText ?? 'The Advanced Airway Cart will be available in 30 minutes.';
				context._scenario.uiWrapper.displayNotificationUI({
					text: `<p class='notification-text'>${txt}</p>`,
					onDismissed: () => {
					}
				})
				context.onDone();
			}, constants.doSomethingTimeout);
		}
	}
}